module.exports = __webpack_public_path__ + "img/gouqi.817cea7d.jpeg";